export default function anyFilter(filters) {
    return (item) => {
        return filters.reduce((acc, filter) => {
            return acc || filter(item);
        }, false);
    };
}
